"use client";

import { ArrowRight as ArrowIcon, MinusIcon, PlusIcon } from "lucide-react";
import RichText from "@blocks/RichText";
import Link from "@components/Link";
import { Disclosure } from "@headlessui/react";
import { useState } from "react";

import { FEATURE_FLAGS } from "@/config/featureFlags";
// import { PageTextBlockFragment } from '@server/gql/graphql';
import { cn } from "@/lib/utils";

export default function FooterTextBlock({
  className,
  data,
  market,
  locale,
}: {
  className?: string;
  data?: /* PageTextBlockFragment */ any;
  market: string;
  locale: string | undefined;
}) {
  const [open, setOpen] = useState(true);

  return (
    <Disclosure as="div" className={className}>
      <h3 className="text-base">
        <Disclosure.Button
          onClick={() => setOpen(!open)}
          className="all-small-caps flex w-full items-center justify-between px-5 py-4 tracking-wider uppercase sm:hidden"
        >
          {data?.title}
          <span className="text-lg sm:hidden">
            {open && <MinusIcon strokeWidth={1} className="size-3" />}
            {!open && <PlusIcon strokeWidth={1} className="size-3" />}
          </span>
        </Disclosure.Button>
        <span className="all-small-caps hidden px-3 pt-4 font-normal tracking-wider uppercase sm:block sm:pb-3">
          {data?.title}
        </span>
      </h3>
      <Disclosure.Panel
        static
        className={cn(
          "max-w-auto px-3 pb-4 text-base sm:max-w-80",
          open ? "block" : "hidden sm:block",
        )}
      >
        <RichText
          content={data?.content}
          className="prose-sm prose-p:m-0 prose-a:font-normal leading-5"
          locale={locale}
          market={market}
        />
        {(FEATURE_FLAGS.customerService.phoneLink && data?.phoneNumber) ||
        (FEATURE_FLAGS.customerService.emailLink && data?.email) ? (
          <div className="mt-6">
            {FEATURE_FLAGS.customerService.phoneLink && data?.phoneNumber ? (
              <p>
                <a
                  className="underline"
                  target="_blank"
                  rel="noreferrer"
                  href={`tel:${data.phoneNumber}`}
                >
                  {data.phoneNumber}
                </a>
              </p>
            ) : null}
            {FEATURE_FLAGS.customerService.emailLink && data?.email ? (
              <p>
                <a
                  className="underline"
                  target="_blank"
                  rel="noreferrer"
                  href={`mailto:${data.email}`}
                >
                  {data.email}
                </a>
              </p>
            ) : null}
          </div>
        ) : null}
        {data?.pageLink?.slug ? (
          <div className="mt-6">
            <Link
              locale={locale}
              href={data?.pageLink?.slug}
              className={cn(
                data?.type === "Accordion"
                  ? "btn-outlined flex items-center justify-center"
                  : "underline",
              )}
            >
              <p>{data?.linkText}</p>
              <ArrowIcon strokeWidth={1} className="ml-1 size-4" />
            </Link>
          </div>
        ) : null}
        <RichText
          locale={locale}
          market={market}
          content={data?.openingHours}
          className="prose-sm prose-p:m-0 prose-a:font-normal mt-6 leading-5"
        />
      </Disclosure.Panel>
    </Disclosure>
  );
}
